/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { GlobalState } from '../../actions';

export const songListState = (state: GlobalState) => state.playlistAdmin.songList;

export const songListSearchString = (state: GlobalState) => songListState(state).searchString;

export const songList = (state: GlobalState) => songListState(state).list;

export const songSearchCount = (state: GlobalState) => songListState(state).searchCount;

export const songSearchCurrentPos = (state: GlobalState) => songListState(state).searchCurrentPos;

export const songSearchPageSize = (state: GlobalState) => songListState(state).searchPageSize;
export const songListIsLoading = (state: GlobalState) => songListState(state).isLoading;
